import _ from 'lodash';
import {
	observable,
	action,
	computed,
	reaction
} from 'mobx';

import config from 'client/shared/config';
import apiStore from './api-store';
import BaseStore from './base-store';

const { routes } = config;

class SearchStore extends BaseStore {
	constructor () {
		super();

		this.disposeSearchReaction = reaction(
			() => this.searchTerm,
			this.search
		);
	}

	/**
	 * Observables & Computeds
	 */

	@observable
	_searchTerm = '';

	@computed
	get searchTerm () {
		return this._searchTerm;
	}

	@computed
	get songResults () {
		return this.searchResults.filter((result) => result.type === 'song');
	}

	@computed
	get artistResults () {
		return this.searchResults.filter((result) => result.type === 'artist');
	}

	@computed
	get albumResults () {
		return this.searchResults.filter((result) => result.type === 'album');
	}

	set searchTerm (searchTerm) {
		this._searchTerm = searchTerm;
	}

	@observable
	_searchResults = [];

	@computed
	get searchResults () {
		return this._searchResults;
	}

	set searchResults (searchResults) {
		this._searchResults = searchResults;
	}

	/**
	 * Actions
	 */

	@action.bound
	async search () {
		if (_.isEmpty(this.searchTerm) || this.searchTerm.length < 3) {

			return;
		}

		this.searchResults = await apiStore.fetch({route: `${routes.search}?s=${this.searchTerm}`});
	}
}


const searchStore = new SearchStore();
export default searchStore;